export function postMessageToCreateCardForTemporaryUse(
  iFrameReference: React.RefObject<HTMLIFrameElement>,
  baseUrl: URL,
) {
  if (!iFrameReference.current) {
    throw new Error(
      "Attempted to call `postMessageToStoreCardForTemporaryUse` with empty iFrameReference",
    );
  }

  const iFrame = iFrameReference.current;
  if (!iFrame.contentWindow) {
    throw new Error(
      "Attempted to call `postMessageToStoreCardForTemporaryUse` but the iFrame contentWindow is null",
    );
  }

  iFrame.contentWindow.postMessage(
    { type: "create-card-for-temporary-use" },
    baseUrl.origin,
  );
}
;
import "/Users/jekri/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";